import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconTrash(props: SvgIconProps) {
  return (
    <SVGIcon width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 3H9L8.52624 11.5277C8.51152 11.7927 8.29237 12 8.02701 12H1.97299C1.70763 12 1.48848 11.7927 1.47376 11.5277L1 3Z"
        stroke="currentColor"
      />
      <path d="M3.5 5L4 10" stroke="currentColor" />
      <path d="M6.5 5L6 10" stroke="currentColor" />
      <path d="M0.5 3H9.5" stroke="currentColor" strokeLinecap="square" />
      <path d="M3 2V1.5C3 1.22386 3.22386 1 3.5 1H6.5C6.77614 1 7 1.22386 7 1.5V2" stroke="currentColor" />
    </SVGIcon>
  );
}
